<template>
  <ModalWithBackdrop
    title="Interconsulta médica"
    :busy="loading.accepting"
    :secondaryBusy="loading.refusing"
    :label="labelAccept"
    :secondaryLabel="labelRefuse"
    v-bind="{ ...$attrs, open }"
    className="requestedInterConsultation"
    @secondaryaction="handleRefuse"
    @action="acceptCall(currentCall.id)"
    @closeclick="handleRefuse"
  >
    <template v-if="currentCall">
      <div class="content__top">
        <PictureCircle class="content__image" :src="currentCall.photoUrl" />
        <div class="content__title">
          {{ currentCall.senderName }} está solicitando sua opinião médica.
        </div>
      </div>
      <div v-if="showMoney" class="content__bottom">
        <Spotlight>
          <span> Você será pago por essa consulta! </span>
          <span class="spotlight__money">
            <MoneyBag />
            <span class="spotlight__money--text">
              {{ currentCall.formatedValue }}
            </span>
          </span>
        </Spotlight>
      </div>
    </template>
  </ModalWithBackdrop>
</template>

<script>
import ModalWithBackdrop from '@/components/ModalWithBackdrop';
import { mapActions, mapState } from 'vuex';
import PictureCircle from '@/components/PictureCircle';
import Spotlight from '@/components/Spotlight';
import MoneyBag from '@/assets/money-bag.svg';
import { Howl } from 'howler';
import callSound from '@/assets/sounds/iphone.mp3';

const callSoundOptions = {
  src: [callSound],
  loop: true,
};

export default {
  name: 'RequestedInterConsultation',

  components: { ModalWithBackdrop, PictureCircle, Spotlight, MoneyBag },

  props: {
    open: { type: Boolean, default: false },
  },

  data: () => ({
    callSound: new Howl(callSoundOptions),
  }),

  computed: {
    ...mapState('callListener', ['currentCall', 'loading']),
    ...mapState('auth', ['userConfigs']),
    showMoney() {
      return (
        !this.userConfigs?.flagNaoPermiteFaturamentoEspecialista &&
        this.currentCall.value
      );
    },
    labelRefuse() {
      return this.loading.refusing ? 'Recusando' : 'Recusar';
    },
    labelAccept() {
      return this.loading.accepting ? 'Aceitando' : 'Aceitar';
    },
  },

  watch: {
    open(isOpen) {
      const action = isOpen ? 'play' : 'stop';

      this.callSound[action]();
    },
  },

  methods: {
    ...mapActions('callListener', ['refuseCall', 'acceptCall']),
    ...mapActions('dashboard', ['closeModals']),
    async handleRefuse() {
      const { currentCall } = this;
      try {
        await this.refuseCall(currentCall.id);
        this.closeModals();
      } catch (err) {}
    },
  },
};
</script>

<style lang="scss" scoped>
@import './style.scss';
</style>

<style lang="scss">
@import './unscopedStyle.scss';
</style>
